import { action } from "mobx";
import * as DocumentManagement from "../DocumentManagement";
import { NewDocumentMetasQuery } from "../DocumentManagement";
import { InputType } from "../Shared";
import { Strings } from "../Stores/StringsStore";
import * as Utilities from "../Utilities";
import { AppStore, IWizardStore, WizardStore } from "./AppStore";
import { DocumentStoreImpl } from "./DocumentStore";


export class DocumentMetaDataWizardStore extends WizardStore implements IWizardStore {

	constructor(public documentStore: DocumentStoreImpl) {
		super();
		let uiLang = Utilities.getUiLanguage();
		if (!uiLang) {
			uiLang = AppStore.context.userInterfaceLanguages[0].name;
		}
		this.language = uiLang;
	}

	language: string;

	/**
  * Open the wizard for adding meta data.
  */
	open = (): void => {
		this.wizardCaption = Strings.documentManagement.documentEdit.addMetaDataCaption;
		this.wizardInformation = Strings.documentManagement.documentEdit.addMetaDataText;
		this.isOpen = true;
	}

	static checkMetaValues(meta: DocumentManagement.DocumentMeta): void {
		let regex = meta.regex ? new RegExp("^" + meta.regex + "$") : null;
		meta.values.forEach((metaValue: DocumentManagement.DocumentMetaValue) => {
			switch (meta.inputType) {
				case InputType.InputText:
					let valueText = metaValue.valueText.value;
					if (!valueText || (regex && !regex.test(valueText))) {
						metaValue.isValid = false;
						metaValue.valueText.isValid = false;
					} else {
						metaValue.isValid = true;
						metaValue.valueText.isValid = true;
						metaValue.validationMessage = "";
						metaValue.valueText.validationMessage = "";
					}
					break;
				case InputType.InputNumber:
					let valueNumber = metaValue.valueNumber.value;
					if (!valueNumber) {
						metaValue.isValid = false;
						metaValue.valueNumber.isValid = false;
					} else {
						metaValue.isValid = true;
						metaValue.valueNumber.isValid = true;
						metaValue.validationMessage = "";
						metaValue.valueNumber.validationMessage = "";
					}
					break;
				case InputType.InputChoice:
					metaValue.isValid = true;
					metaValue.valueChoice.isValid = true;
					metaValue.validationMessage = "";
					metaValue.valueChoice.validationMessage = "";
					break;
				case InputType.InputDate:
					let valueDate = metaValue.valueDate.value;
					if (!valueDate) {
						metaValue.isValid = false;
						metaValue.valueDate.isValid = false;
					} else {
						metaValue.isValid = true;
						metaValue.valueDate.isValid = true;
						metaValue.validationMessage = "";
						metaValue.valueDate.validationMessage = "";
					}
					break;
				case InputType.InputHierarchy:
					let valueHierarchy = metaValue.valueHierarchy.value;
					if (!valueHierarchy || (regex && !regex.test(valueHierarchy))) {
						metaValue.isValid = false;
						metaValue.valueHierarchy.isValid = false;
					} else {
						metaValue.isValid = true;
						metaValue.valueHierarchy.isValid = true;
						metaValue.validationMessage = "";
						metaValue.valueHierarchy.validationMessage = "";
					}
					break;
				case InputType.InputDocumentLink:
					let valueDocumentLink = metaValue.valueDocumentLink.value;
					if (!valueDocumentLink || (regex && !regex.test(valueDocumentLink))) {
						metaValue.isValid = false;
						metaValue.valueDocumentLink.isValid = false;
					} else {
						metaValue.isValid = true;
						metaValue.valueDocumentLink.isValid = true;
						metaValue.validationMessage = "";
						metaValue.valueDocumentLink.validationMessage = "";
					}
					break;
				default:
					throw "unknown InputType";
			}
		});
	}

	onConfirmExternal = () => {

	}

	/**
   * Callback for confirming the wizard operation.
   */
	@action onConfirmWizard = () => {
		this.isOpen = false;
		let query = new NewDocumentMetasQuery();
		query.metaIds = this.documentStore.addedDocumentMetas;
		query.language = this.language;
		DocumentManagement.getNewDocumentMetasAsync(query).then((documentMetas) => {
			documentMetas.forEach(dm => {
				DocumentMetaDataWizardStore.checkMetaValues(dm);
			});
			this.documentStore.model.metas.push(...documentMetas);
		});
		this.documentStore.addedDocumentMetas.clear();
		this.onConfirmExternal();
	}

	/**
	* Callback fro canceling the wizard operation.
	*/
	@action onCancelWizard = () => {
		this.isOpen = false;
		this.documentStore.addedDocumentMetas.clear();
	}

}